import {LEARNING_PLAN_IN_LEERPLATFORM} from '@/learningplan/learningPlanApiUrl.js';

/**
 * The flag in `enabledFeatureFlags` with which a portal switches classroom over from learning-academy to the
 * leerplatform (ADR 0008).
 */
export const CLASSROOM_IN_LEERPLATFORM = 'classroomInLeerplatform';

export {LEARNING_PLAN_IN_LEERPLATFORM};

/**
 * The base url of the classroom endpoints: the leerplatform API once the portal has switched both classroom and
 * learning plans over, the academy until then. The paths and bodies are the same on both, and reads follow the
 * same host as writes.
 *
 * Both flags, because the leerplatform only serves classroom writes when both are on (`IClassroomWrite`): an enroll
 * signals the learning plan, and while the academy still serves learning plans its engine owns the instance. With
 * only `classroomInLeerplatform` on, the leerplatform refuses the writes, so the screens stay with the academy.
 */
export const classroomApiUrl = (settings) =>
    settings.enabledFeatureFlags?.[CLASSROOM_IN_LEERPLATFORM] &&
    settings.enabledFeatureFlags?.[LEARNING_PLAN_IN_LEERPLATFORM]
        ? settings.apiUrl
        : settings.portalApiUrl;
